<template>
  <v-navigation-drawer
    :model-value="newActionComponentProps"
    class="rm-right-drawer"
    @update:model-value="handleModelValueChange"
    temporary
    :order="-1"
    location="right"
    width="545"
  >
    <NewActions
      v-if="newActionComponent"
      :currentRepairFile="currentRepairFile"
      :rentalFileId="rentalFileId"
      @closeNewAction="handleCloseNewAction()"
      @openDeliveryClient="(action) => handleOpenDeliveryClient(action)"
      @openEstimateRepairer="handleOpenEstimateRepairer()"
      @openEstimateRepairerDetail="handleOpenEstimateRepairerDetail()"
      @updateCurrentRepairFile="handleUpdateRepairFile()"
      @openRentalWarningModal="handleOpenRentalWarningModal()"
    />
    <DeliveryClient
      v-if="deliveryClientComponent"
      :currentRepairFile="currentRepairFile"
      :actionType="deliveryActionType"
      @cancelDeliveryClient="handleCancelDeliveryClient()"
      @closeDeliveryClient="handleCloseDeliveryClient()"
      @updateCurrentRepairFile="handleUpdateRepairFile()"
    />
    <EstimateRepairer
      v-if="estimateRepairerComponent"
      :currentRepairFile="currentRepairFile"
      :refreshCurrentRepairFile="refreshCurrentRepairFile"
      @cancelEstimateRepairer="handleCancelEstimateRepairer()"
      @updateCurrentRepairFile="handleUpdateRepairFile()"
      @closeNewAction="handleCloseNewAction()"
    />
  </v-navigation-drawer>
</template>

<script>
import DeliveryClient from '@/components/repair-files/right-drawer/DeliveryClient.vue'
import NewActions from '@/components/repair-files/right-drawer/NewActions.vue'
import EstimateRepairer from '@/components/repair-files/right-drawer/estimate-repairer/EstimateRepairer.vue'

import { checkPermission } from '@/utils/permissionUtils'
import { displayToast } from '@/utils/toastUtils'

export default {
  components: { EstimateRepairer, NewActions, DeliveryClient },
  props: {
    newActionComponentProps: Boolean,
    currentRepairFile: Object,
    rentalFileId: [Object, Number, String],
    openDeliveryClientDrawer: Boolean,
    refreshCurrentRepairFile: Function
  },
  data() {
    return {
      loading: false,
      error: null,
      newActionComponent: false,
      deliveryClientComponent: false,
      estimateRepairerComponent: false,
      deliveryActionType: undefined,
      bodyOverflowBeforeOpen: null,
      htmlOverflowBeforeOpen: null
    }
  },
  unmounted() {
    this.setBodyScrollLocked(false)
  },
  watch: {
    newActionComponentProps() {
      if (this.newActionComponentProps === true) {
        this.setBodyScrollLocked(true)
        if (this.openDeliveryClientDrawer) {
          this.handleOpenDeliveryClient('close')
          return
        }
        this.newActionComponent = true
        this.deliveryClientComponent = false
        this.estimateRepairerComponent = false
        this.$emit('reset-delivery-client-state', false)
      } else {
        this.setBodyScrollLocked(false)
        this.newActionComponent = false
        this.deliveryClientComponent = false
        this.estimateRepairerComponent = false
        this.deliveryActionType = undefined
        this.$emit('reset-delivery-client-state', false)
      }
    }
  },
  methods: {
    checkPermission,
    setBodyScrollLocked(shouldLock) {
      if (shouldLock) {
        if (this.bodyOverflowBeforeOpen === null) {
          this.bodyOverflowBeforeOpen = document.body.style.overflow
        }
        if (this.htmlOverflowBeforeOpen === null) {
          this.htmlOverflowBeforeOpen = document.documentElement.style.overflow
        }
        document.documentElement.style.overflow = 'hidden'
        document.body.style.overflow = 'hidden'
      } else {
        document.documentElement.style.overflow = this.htmlOverflowBeforeOpen ?? ''
        document.body.style.overflow = this.bodyOverflowBeforeOpen ?? ''
        this.bodyOverflowBeforeOpen = null
        this.htmlOverflowBeforeOpen = null
      }
    },
    handleModelValueChange(value) {
      if (value === false) {
        this.$emit('close')
      }
    },
    handleCloseNewAction() {
      this.$emit('close')
    },
    handleOpenDeliveryClient(actionType) {
      const requiredPermission =
        actionType === 'close' ? 'DISTRIBUTOR_CLOSE_REPAIR_FILE' : 'DISTRIBUTOR_UPDATE_REPAIR_FILE'
      if (checkPermission([requiredPermission])) {
        this.newActionComponent = false
        this.deliveryClientComponent = true
        this.deliveryActionType = actionType
      } else {
        displayToast(this.$t('COMMON.NOT_AUTHORIZED_ACTION_MESSAGE'), 'warning')
      }
    },
    handleCancelDeliveryClient() {
      this.newActionComponent = true
      this.deliveryClientComponent = false
      this.deliveryActionType = undefined
    },
    handleCloseDeliveryClient() {
      const requiredPermission =
        this.deliveryActionType === 'close'
          ? 'DISTRIBUTOR_CLOSE_REPAIR_FILE'
          : 'DISTRIBUTOR_UPDATE_REPAIR_FILE'
      if (checkPermission([requiredPermission])) {
        this.$emit('updateCurrentRepairFile')
        this.$emit('showGuaranteeExtensionBoomerangModal')
        this.$emit('close')
      } else {
        displayToast(this.$t('COMMON.NOT_AUTHORIZED_ACTION_MESSAGE'), 'warning')
      }
    },
    handleUpdateRepairFile() {
      this.$emit('updateCurrentRepairFile')
    },
    async handleOpenEstimateRepairer() {
      if (checkPermission(['DISTRIBUTOR_UPDATE_REPAIR_FILE'])) {
        if (this.refreshCurrentRepairFile) {
          const refreshed = await this.refreshCurrentRepairFile()
          if (refreshed === false) return
        }
        this.newActionComponent = false
        this.estimateRepairerComponent = true
      } else {
        displayToast(this.$t('COMMON.NOT_AUTHORIZED_ACTION_MESSAGE'), 'warning')
      }
    },
    handleCancelEstimateRepairer() {
      this.newActionComponent = true
      this.estimateRepairerComponent = false
    },
    async handleOpenEstimateRepairerDetail() {
      if (checkPermission(['DISTRIBUTOR_UPDATE_REPAIR_FILE'])) {
        if (this.refreshCurrentRepairFile) {
          const refreshed = await this.refreshCurrentRepairFile()
          if (refreshed === false) return
        }
        this.newActionComponent = false
        this.estimateRepairerComponent = true
      } else {
        displayToast(this.$t('COMMON.NOT_AUTHORIZED_ACTION_MESSAGE'), 'warning')
      }
    },
    handleOpenRentalWarningModal() {
      if (checkPermission(['DISTRIBUTOR_RENTAL_CREATE'])) {
        this.$emit('openRentalWarningModal')
      } else {
        displayToast(this.$t('COMMON.NOT_AUTHORIZED_ACTION_MESSAGE'), 'warning')
      }
    }
  }
}
</script>
